import emailjs from '@emailjs/browser';

// CONFIGURATION
const SERVICE_ID = 'service_e28yrvr';
const TEMPLATE_ID = 'template_lq0atjq';
const PUBLIC_KEY = 'CXGIBmc6aF9yGPmGw';

export const EmailService = {
    /**
     * Send an email notification
     * @param {Object} params - The template parameters
     * @returns {Promise<boolean>} - Success status
     */
    sendEmail: async (params) => {
        try {
            const response = await emailjs.send(SERVICE_ID, TEMPLATE_ID, params, PUBLIC_KEY);
            return true;
        } catch (error) {
            console.error('Failed to send email:', error);
            return false;
        }
    },

    /**
     * Send a notification when a permit is submitted
     * @param {Object} permit - The permit data
     * @param {Array<string>} recipients - List of email addresses (e.g. WVs)
     */
    sendSubmissionNotification: async (permit, recipients = []) => {
        if (!recipients || recipients.length === 0) {
            console.warn('No recipients provided for submission notification.');
            return false;
        }

        // EmailJS usually sends to one address per call unless using a specific feature or loop.
        // We will loop through recipients to ensure everyone gets a copy (simplest approach).
        // Or if the template supports CC/BCC, we could use that, but simple loop is safer for now.


        const promises = recipients.map(email => {
            const params = {
                to_email: email,
                to_name: 'Werkverantwoordelijke',
                name: permit.username || permit.applicantName || 'Onbekend', // "A message by {{name}}"
                locatie: permit.location,
                taak: permit.task,
                door: permit.username || permit.applicantName || 'Onbekend',
                datum: new Date(permit.createdAt || Date.now()).toLocaleDateString('nl-NL'),
                link: window.location.origin
            };
            return EmailService.sendEmail(params);
        });

        const results = await Promise.all(promises);
        return results.every(r => r === true);
    },

    /**
     * Send a notification when a permit status changes
     * @param {Object} permit - The permit data
     * @param {string} status - The new status
     * @param {string} feedback - Optional feedback
     */
    sendStatusUpdateNotification: async (permit, status, feedback = '') => {
        const params = {
            to_name: permit.username,
            to_email: permit.username || permit.applicantName, // Fallback if username is not email
            name: 'RaconWorks System',
            locatie: permit.location,
            taak: permit.task,
            door: 'Admin', // Context
            datum: new Date().toLocaleDateString('nl-NL'),
            message: `De status van uw werkplan is gewijzigd naar: ${status.toUpperCase()}.\n\n${feedback ? `Feedback: ${feedback}` : ''}`,
            link: window.location.origin
        };
        return EmailService.sendEmail(params);
    },

    /**
     * Send a notification when a Force Unlock is triggered
     * @param {Object} permit - The permit data
     * @param {Object} user - The user executing the force unlock (Planner/Admin)
     * @param {string} reason - The justification
     */
    sendEmergencyNotification: async (permit, user, reason, recipients) => {
        if (!recipients || recipients.length === 0) {
            console.warn("📧 Emergency Email skipped: No recipients defined.");
            return false;
        }

        const timestamp = new Date().toLocaleString('nl-NL');

        // Send to each recipient (bulk or individual loop)
        // Using loop to ensure delivery to multiple people if needed
        const promises = recipients.map(email => {
            const params = {
                to_name: "Safety Officer / Werkverantwoordelijke", // Generic salutation
                to_email: email,
                name: user.username || user.email,
                locatie: permit.location,
                taak: permit.task,
                door: user.username || "System Admin",
                datum: timestamp,
                message: `⚠️ NOODPROCEDURE GEACTIVEERD ⚠️\n\nGebruiker '${user.username}' heeft een geforceerde ontgrendeling (Force Unlock) uitgevoerd.\n\nReden: "${reason}"\n\nStatus is gewijzigd naar: TERMINATED.`,
                link: window.location.origin
            };
            return EmailService.sendEmail(params);
        });

        console.warn("📧 Sending Emergency Emails to:", recipients);
        const results = await Promise.all(promises);
        return results.every(res => res === true);
    }
};
